module.exports = __webpack_public_path__ + "static/media/Reservation-02.83b7a636.svg";